module.exports = __webpack_public_path__ + "img/cancercouncil-qld.3b60b67.png";